import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container" }

import {
  onMounted,
  ref,
  watch,
  computed,
} from 'vue';
import { Forms, Genres } from '@/api/spotwrite';
import SwTopPageTemplate from '@/components/templates/SwTopPageTemplate.vue';
import { SAVE_SEARCH_KEYWORD_MUTATION, useStore } from '@/store';
import SwAppHeader from '@/components/organisms/SwAppHeader.vue';
import SwAppFooter from '@/components/organisms/SwAppFooter.vue';
import SwWorkNavigation from '@/components/organisms/Navigations/SwWorkNavigation.vue';
import SwPostWorkNavigation from '@/components/organisms/Navigations/SwPostWorkNavigation.vue';
import SwCreateAccountBanner from '@/components/organisms/Banners/SwCreateAccountBanner.vue';
import SwCirclesSection from './SwCirclesSection.vue';
import SwPopularTagsSection from './SwPopularTagsSection.vue';
import SwCalousel from './SwCalousel.vue';
import SwAnnouncementLine from './SwAnnouncementLine.vue';
import SwNewWorksSection from './SwNewWorksSection.vue';
import SwPopularWorksSection from './SwPopularWorksSection.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();
const genres = computed(() => store.state.genres);
const forms = computed(() => store.state.forms);

const selectedForm = ref<Forms>();
const selectedGenre = ref<Genres>();

const searchKeyword = computed(() => store.state.searchKeyword);
const searchKeywordValue = computed({
  get: () => searchKeyword.value,
  set: (value) => {
    store.commit(SAVE_SEARCH_KEYWORD_MUTATION, { searchKeyword: value });
  },
});

const onChangeGenre = (genre: Genres | undefined) => {
  selectedGenre.value = genre;
};
const onChangeForm = (form: Forms | undefined) => {
  selectedForm.value = form;
};

onMounted(async () => {
  // 検索キーワード初期化
  searchKeywordValue.value = '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SwTopPageTemplate, null, {
    "app-header": _withCtx(() => [
      _createVNode(SwAppHeader),
      _createVNode(SwPostWorkNavigation)
    ]),
    carousel: _withCtx(() => [
      _createVNode(SwCalousel)
    ]),
    announcement: _withCtx(() => [
      _createVNode(SwAnnouncementLine)
    ]),
    banner: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SwCreateAccountBanner)
      ])
    ]),
    "work-navigation": _withCtx(() => [
      _createVNode(SwWorkNavigation, {
        processes: _unref(forms),
        genres: _unref(genres),
        "onChange:form": onChangeForm,
        "onChange:genre": onChangeGenre
      }, null, 8, ["processes", "genres"])
    ]),
    "new-works": _withCtx(() => [
      _createVNode(SwNewWorksSection, {
        form: selectedForm.value,
        genre: selectedGenre.value
      }, null, 8, ["form", "genre"])
    ]),
    "popular-works": _withCtx(() => [
      _createVNode(SwPopularWorksSection, {
        form: selectedForm.value,
        genre: selectedGenre.value
      }, null, 8, ["form", "genre"])
    ]),
    "popular-tags": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SwPopularTagsSection)
      ])
    ]),
    "app-footer": _withCtx(() => [
      _createVNode(SwAppFooter)
    ]),
    _: 1
  }))
}
}

})